/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetSummary200,
  GetRates200,
  GetRatesParams
} from './schema'



/**
 * @summary Get summary
 */
export const getSummary = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetSummary200>> => {
    return axios.get(
      `/summary`,options
    );
  }


export const getGetSummaryQueryKey = () => [`/summary`];

    
export type GetSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getSummary>>>
export type GetSummaryQueryError = AxiosError<unknown>

export const useGetSummary = <TData = Awaited<ReturnType<typeof getSummary>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSummaryQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSummary>>> = ({ signal }) => getSummary({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getSummary>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * @summary Get exchange rates for a given base currency
 */
export const getRates = (
    params: GetRatesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetRates200>> => {
    return axios.get(
      `/rates`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetRatesQueryKey = (params: GetRatesParams,) => [`/rates`, ...(params ? [params]: [])];

    
export type GetRatesQueryResult = NonNullable<Awaited<ReturnType<typeof getRates>>>
export type GetRatesQueryError = AxiosError<unknown>

export const useGetRates = <TData = Awaited<ReturnType<typeof getRates>>, TError = AxiosError<unknown>>(
 params: GetRatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRates>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRatesQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRates>>> = ({ signal }) => getRates(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getRates>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

